import type { ReactNode } from 'react';
import { da } from '../i18n/da';
import styles from './SkyPage.module.css';

/** The sky with drifting clouds, logo and grass that frames every menu page. */
export function SkyPage({ children }: { children: ReactNode }) {
  return (
    <main className={styles.page}>
      <div className={styles.cloudA} aria-hidden="true" />
      <div className={styles.cloudB} aria-hidden="true" />

      <header className={styles.header}>
        <h1 className={styles.logo}>{da.appName}</h1>
        <p className={styles.tagline}>{da.tagline}</p>
      </header>

      {children}

      <div className={styles.ground} aria-hidden="true" />
    </main>
  );
}
